import React from 'react';
import { createRoot } from 'react-dom/client';
import { inject } from '@vercel/analytics';
import '../sass/main.scss';
import './styles.css';
import canvasDotsBg from '../bgCanvas.js';
import setupMobileNav from '../nav.js';
import ProjectsSection from './App';

// Initialize Vercel Analytics
inject();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<ProjectsSection />);

canvasDotsBg();
setupMobileNav();
